import React from "react";
import styled from "styled-components";
import { Error } from "../../service";

const Wrap = styled.div`
  border: 1px dashed #dcdcdc;
`;

export default ({ error, filename, ...props }) => (
  <label>
    <Wrap className="flex items-center f6 justify-center pa3 br2 pointer mb1">
      <div className="pointer">
        <input type="file" {...props} style={{ display: "none" }} />
        {!filename
          ? "Click here to upload your resume in PDF or Word"
          : filename}
      </div>
    </Wrap>
    {error && <Error>{error}</Error>}
  </label>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/native/File/index.js